<template>
    
    <div class="container py-5 mt-5">
        <div class="mt-5">
            <h3>مدرس های ناباکو</h3>
            <div class="row mt-5">
                <div class="col-md-4">
                    <div>
                        <img src="../../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-end px-5">
                        <h3>دکتر حسین مالکی نژاد</h3>
                        <h5>رئیس هیئت مدیره</h5>
                        <h5>سابقه فعالیت مدیر تکنولوژی فناوری های بانکی</h5>
                        <h5>دکترای هوش مصنوعی و یادگیری ماشین</h5>
                        <h5>راه اندازی سیستم های های پیش بینی در صنعت مالی </h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <img src="../../../public/img/miladTarverdi.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-end px-5">
                        <h3>دکتر میلاد تاروردی</h3>
                        <h5>مدیر راهکارها و بازاریابی ناباکو</h5>
                        <h5>دکترای دیجیتالیزیشن از دانشگاه تهران</h5>
                        <h5>دکترای مدیریت کسب و کار - گرایش تحول دیجیتال</h5>
                        <h5>مدرس دوره های آموزشی MBA وکسب و کار</h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <img src="../../../public/img/PoriaKhani.png" width="100%" alt="">
                    </div>
                    <div class="my-auto text-end px-5">
                        <h3>مهندس پوریا خانی</h3>
                        <h5>مدرس</h5>
                        <h5>متخصص هوش مصنوعی و دیتا ساینس</h5>
                        <h5>تخصص در زمینه یادگیری ماشین و یاد گیری عمیق</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5 pt-5">
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/1.png" alt="">
                        <h6 class="mt-3 fw-bold">درک هوش مصنوعی و کاربردهای آن در امور مالی</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 15 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/2.jpg" alt="">
                        <h6 class="mt-3 fw-bold">تجزیه و تحلیل انتخاب سهام در بازارهای بین المللی مبتنی بر هوش مصنوعی</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 15 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/3.jpg" alt="">
                        <h6 class="mt-3 fw-bold">مدیریت ریسک با هوش مصنوعی</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 30 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/4.png" alt="">
                        <h6 class="mt-3 fw-bold">تجارت الگوریتمی و ربات های سرمایه گذاری</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 30 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/5.jpg" alt="">
                        <h6 class="mt-3 fw-bold">پیش بینی بازار با استفاده از یادگیری ماشین</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 30 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/6.jpg" alt="">
                        <h6 class="mt-3 fw-bold">تحلیل احساسات و تصمیم گیری</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 30 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/7.jpg" alt="">
                        <h6 class="mt-3 fw-bold">ملاحظات و چالش ها</h6>
                        <div style="font-size: 15px;">مدرس : دکتر حسین مالکی نژاد</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 30 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/8.jpg" alt="">
                        <h6 class="mt-3 fw-bold">مقدمه ای بر تحول دیجیتال در بانکداری</h6>
                        <div style="font-size: 15px;">مدرس : دکتر میلاد تاروردی</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 45 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/9.jpg" alt="">
                        <h6 class="mt-3 fw-bold">فناوری های محرک دیجیتال در بانکداری</h6>
                        <div style="font-size: 15px;">مدرس : دکتر میلاد تاروردی</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 60 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/10.jpg" alt="">
                        <h6 class="mt-3 fw-bold">تحول در سیستم های پرداخت</h6>
                        <div style="font-size: 15px;">مدرس : دکتر میلاد تاروردی</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 60 دقیقه</div>
                    </div>
                </div>
                <div class="col-md-4 my-3">
                    <div class="card">
                        <img src="../../assets/period-img/11.png" alt="">
                        <h6 class="mt-3 fw-bold">چالش ها، فرصت ها و نقشه راه برای بانک ها</h6>
                        <div style="font-size: 15px;">مدرس : دکتر میلاد تاروردی</div>
                        <div style="font-size: 15px;">نحوه برگزاری : حضوری</div>
                        <div style="font-size: 15px;">مدت دوره : 45 دقیقه</div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.card {
    border:none;
    box-shadow: 0px 0px 5px 0px #b6b6b6;
}
</style>